import { css } from "@emotion/react";
import { Dropdown } from "@zapier/design-system";

const intervalContainer = css`
  width: 100%;
`;

type Props = {
  /* Discount to be displayed for Annual plans in percent */
  annualDiscountPercent: number;
  onChange: (_: boolean) => void;
  isAnnual: boolean;
};

const YEARLY = "yearly";
const MONTHLY = "monthly";

export const IntervalDropdown = ({
  annualDiscountPercent,
  isAnnual,
  onChange: setIsAnnual,
}: Props) => {
  const items = [
    { label: "Pay monthly", value: MONTHLY },
    { label: `Pay yearly (Save ${annualDiscountPercent}%)`, value: YEARLY },
  ];
  const planDuration = isAnnual ? YEARLY : MONTHLY;
  const selectedItem = items.find((item) => item.value === planDuration);
  return (
    <div css={intervalContainer}>
      <Dropdown
        menuAriaLabel="Plan Duration"
        placeholder="Select a plan duration"
        getLabelForItem={(item) => item.label}
        items={items}
        selectedItem={selectedItem}
        onChange={(item) =>
          item.value === YEARLY ? setIsAnnual(true) : setIsAnnual(false)
        }
      />
    </div>
  );
};
